import React from 'react';
import { Grid, Typography, CardContent } from '@mui/material';
import { StyledCard, ImageWithPreview } from './shared';
import { getHTTPUrlFromS3Path } from '../../../utils/outputs';

interface VisualDefect {
  type: string;
  image: string;
  caption: string;
  bbox: any;
}

interface VisualDefectsSectionProps {
  visualDefects: VisualDefect[];
}

const VisualDefectsSection: React.FC<VisualDefectsSectionProps> = ({ visualDefects }) => {
  if (!visualDefects?.length) return null;
  return (
    <Grid item xs={12}>
      <Typography variant="h2" sx={{ mb: 2 }}>Visual Defects</Typography>
      <Grid container spacing={2}>
        {visualDefects.map((defect, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <StyledCard>
              <ImageWithPreview
                src={(url => url.endsWith('/') ? url.slice(0, -1) : url)(getHTTPUrlFromS3Path(defect.image))}
                alt={defect.caption}
                identifier={`defect-${index}`}
              />
              <CardContent sx={{ backgroundColor: '#1111' }}>
                <Typography variant="h6">{defect.type}</Typography>
                <Typography>{defect.caption}</Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default VisualDefectsSection;
